/* src/app/basket/basket.component.scss */
.main-bgColor {
  min-height: 100vh;
}
.ad-card {
  text-align: center;
  margin: 10px;
}
/*# sourceMappingURL=basket.component.css.map */
